import { AdSlot, TEMPLATE, TemplateStateHandler } from '@wikia/ad-engine';
import { Inject, Injectable } from '@wikia/dependency-injection';

@Injectable({ autobind: false })
export class BflaMuteYTEmbed implements TemplateStateHandler {
	constructor(@Inject(TEMPLATE.SLOT) private adSlot: AdSlot) {}

	// Mute Youtube embed when entering the slot
	async onEnter(): Promise<void> {
		const iframe = this.adSlot.getIframe();

		if (iframe && iframe.contentWindow) {
			iframe.contentWindow.postMessage('mute', '*');
		}
	}
}
